import { formatISO } from 'date-fns';
import type { CreatedAt } from './notificationsReducer';

export const createCreatedAt = (date: Date = new Date()): CreatedAt => formatISO(date);
